export default __webpack_public_path__ + "static/media/THSarabunNewBold.bba24ce8.ttf";